import { useAppSelector } from "slice";

export const usePersonalInfo = () => {
    const {
        data: {
            attributes: { gender, nationality, dob, qualification },
        },
    } = useAppSelector((state) => state.model);
    return {
        gender,
        nationality,
        dob,
        qualification,
    };
};
